import React from 'react';
import { Icon } from '@fluentui/react';
import SidePanelAlerts from './SidePanelAlerts';
import { useGetNotificationCounter } from '../../../../hooks/services/NotificationTask/useOfNotificacionTask';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { action_updateAlertDialogTitle, action_updateIsPanelNotificationOpen } from '../../../../reducers/actions/SITE/actions';
import './style.css';
import { isNull } from 'lodash-es';
import { isNullUndefinedOrEmpty } from '../../../../common/Helpers';

function NotificationAlert(props) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const {

        _firsLoadCounter: firsLoadCounter,
        _alertCounter: alertCounter,
        _alertSearchIdentifiers: alertSearchIdentifiers,
        _isPanelNotificationAlertOpen: isPanelNotificationAlertOpen
    } = useSelector((state) => state.notificationAlertState);

    useGetNotificationCounter(alertCounter, firsLoadCounter)

    const handleAlertClick = () => {
        dispatch(action_updateAlertDialogTitle('data-lang-boxname-notificationalerts'))
        dispatch(action_updateIsPanelNotificationOpen(true))
    }

    return (
        <>
            <div className="icon cursor-pointer">
                <Icon iconName='Ringer' onClick={handleAlertClick} title={alertCounter ? t('data-lang-msg-alertcountericon-on') : t('data-lang-msg-alertcountericon-off') } styles={{root: { color: "white", fontSize: "20px"}}} />
                {
                    (firsLoadCounter && !isNull(alertCounter) && alertCounter > 0) &&
                    <div onClick={handleAlertClick} className="alertgolve text-center my-auto"><b>{alertCounter > 99 ? `${alertCounter}+` : alertCounter}</b></div>
                }
            </div>
            {
                isPanelNotificationAlertOpen && isNullUndefinedOrEmpty(alertSearchIdentifiers.rootId) && isNullUndefinedOrEmpty(alertSearchIdentifiers.itemId) &&
                <SidePanelAlerts />
            }
        </>
    );
}
    
export default NotificationAlert;